import axios from 'axios';
import { takeEvery, call, put } from 'redux-saga/effects';

import { FETCH_POWER_BENCHMARKS, FETCH_POWER_BENCHMARKS_SUCCESS } from '../actions/ActionTypes';

export function* fetchPowerBenchmarks() {
    try {
        const response = yield call(axios.get, '/web-data/userprofile/biometric/bioRanges/ftpBioRanges.json', {
            baseURL: '/'
        });

        yield put({
            type: FETCH_POWER_BENCHMARKS_SUCCESS,
            benchmarks: response.data
        });
    } catch (e) {}
}

export const powerBenchmarksSagas = [takeEvery(FETCH_POWER_BENCHMARKS, fetchPowerBenchmarks)];
